
import {
    ArrayInput, SimpleFormIterator, NumberInput,
    FormDataConsumer,
    required,
} from "react-admin";

import { PriceCalculator } from "../PriceCalculator";
import { Divider, Paper, Stack } from '@mui/material';
import { CountriesSelector, CurrencySelector } from "@/src/components";



export const PricingInput = (props: any) => {

    return (
        <>
            <Divider textAlign="left">Pricing</Divider>
            <ArrayInput {...props} label={false}>
                <SimpleFormIterator>
                    <CountriesSelector label="Countries" source="countries" />
                    <FormDataConsumer>{({ formData, scopedFormData }) =>
                        <Stack>
                            <Stack direction={"row"} spacing={2}>
                                <CurrencySelector type="product" source="currency" label="currency" validate={required()} />
                                <NumberInput source="price" step={1} label="price" validate={required()} />
                                <NumberInput source="priceOld" step={1} label="Price Old" />
                            </Stack>
                            <PriceCalculator />
                            
                        </Stack>
                    }
                    </FormDataConsumer>
                </SimpleFormIterator >
            </ArrayInput>

        </>
    )
}

